import { getOnboardingRuntimeConfig } from './onboarding-presenter';

export function buildLiveDialogPanelMarkup(): string {
  return `
    <aside class="onboarding-avatar-panel onboarding-live-panel" id="onboarding-avatar-panel" aria-label="Живой диалог с проводником">
      <div class="onboarding-avatar-stage" id="onboarding-avatar-stage">
        <video id="onboarding-avatar-video" class="onboarding-avatar-video" playsinline hidden></video>
        <p class="onboarding-avatar-replica" id="onboarding-avatar-replica" aria-live="polite"></p>
      </div>
      <div class="onboarding-live-dialog" id="onboarding-live-dialog">
        <p class="onboarding-live-hint" id="onboarding-live-hint"></p>
        <div class="onboarding-live-controls">
          <button
            type="button"
            class="onboarding-btn onboarding-btn-secondary"
            id="onboarding-live-mic"
            aria-label="Задать вопрос голосом"
          >
            Спросить голосом
          </button>
          <button
            type="button"
            class="onboarding-btn onboarding-btn-primary"
            id="onboarding-live-return-wizard"
            data-onboarding-action="live-return-wizard"
          >
            Вернуться к записи
          </button>
        </div>
        <form id="onboarding-live-text-form" class="onboarding-live-text-form">
          <label class="onboarding-field-label" for="onboarding-live-text-input">Или введите вопрос</label>
          <input
            type="text"
            id="onboarding-live-text-input"
            class="onboarding-clarify-input"
            maxlength="500"
            placeholder="Например: что такое реакция?"
            autocomplete="off"
          />
          <button type="submit" class="onboarding-btn onboarding-btn-secondary">Спросить</button>
        </form>
        <div class="onboarding-live-answer" id="onboarding-live-answer" hidden aria-live="polite"></div>
      </div>
    </aside>
  `;
}

export function updateLiveDialogHint(used: number, max: number) {
  const hint = document.getElementById('onboarding-live-hint');
  if (!hint) return;
  const remaining = Math.max(0, max - used);
  hint.textContent =
    remaining > 0
      ? `Осталось реплик диалога: ${remaining} из ${max}`
      : 'Лимит диалога исчерпан — продолжайте запись.';
}

export function showLiveDialogAnswer(text: string) {
  const box = document.getElementById('onboarding-live-answer');
  if (!box) return;
  box.hidden = false;
  box.textContent = text;
}

export function setLiveMicListening(listening: boolean) {
  const btn = document.getElementById('onboarding-live-mic');
  if (!btn) return;
  btn.textContent = listening ? 'Слушаю…' : 'Спросить голосом';
  btn.setAttribute('aria-pressed', listening ? 'true' : 'false');
}

export function getLiveDialogLimits(): { maxTurns: number; timeoutMin: number } {
  const dialog = getOnboardingRuntimeConfig().avatar?.dialog;
  return {
    maxTurns: dialog?.max_turns ?? 20,
    timeoutMin: dialog?.timeout_min ?? 10,
  };
}
